<template>

    <BaseListbox
        v-model="model"
        :ajax="true"
        :autoclose="false"
        :filter="filter"
        :searchable="true"
        :value="option => option.id"
        :label="option => trans({ en: option.name_en, fr: option.name_fr })"
        :min-chars="minChars"
        :multiple="true"
        :search="search"
        :creatable="true"
        :create="() => $refs.form?.create()"/>

    <BaseDrawer :title="$t('labels.category-create')">
        <CategoryForm ref="form"/>
    </BaseDrawer>

</template>

<script setup>
    import { options } from '@/api'
    import { useTrans } from '@/composables/i18n'

    const emit = defineEmits(['update:modelValue'])

    const props = defineProps({
        modelValue: { required: true },
        searchRequired: { type: Boolean, default: false }
    })

    const modelValue = toRef(props, 'modelValue')
    const searchRequired = toRef(props, 'searchRequired')

    const trans = useTrans()
    const model = useVModel(props, 'modelValue', emit)
    
    const form = ref()
    const filter = computed(() => searchRequired.value ? false : true)
    const minChars = computed(() => searchRequired.value ? 3 : -1)

    const search = async (args) => {
        let params = {}

        if (args.query) {
            params.search = args.query
        }

        if (args.values) {
            params.ids = args.values
        }

        const response = await options.categories(params)

        return response.data
    }

    defineExpose({ search })    
</script>
